import React, { type ReactElement } from 'react';
import clsx from 'clsx';
import type { UseComboboxPropGetters } from 'downshift';
import type { ComboBoxItem } from 'atom-components/combo-boxes/types';
import styles from './menu-item.module.scss';

type Props = {
  isSelected: boolean;
  isHighlighted: boolean;
  item: ComboBoxItem;
  index: number;
  getItemProps: UseComboboxPropGetters<ComboBoxItem>['getItemProps'];
};

export default function MenuItem({
  isSelected,
  isHighlighted,
  item,
  index,
  getItemProps
}: Props): ReactElement {
  return (
    <li
      {...getItemProps({ item, index })}
      className={clsx(
        styles.item,
        { 'd-block': item.badge },
        { [`${styles.selectedItemHighlighted}`]: isSelected },
        { [`${styles.availableItemHighlighted}`]: isHighlighted }
      )}
    >
      {item.badge ? item.badge : <span>{item.name}</span>}
    </li>
  );
}
